import type { ReactNode } from "react";

interface FilterFieldShellProps {
    label: string;
    children: ReactNode;
}

export const FilterFieldShell = ({ label, children }: FilterFieldShellProps) => {
    return (
        <div className="flex flex-col gap-1.5 min-w-0">
            <span className="font-display font-semibold text-sm uppercase tracking-[0.14em] text-[var(--fg-2)] text-center">
                {label}
            </span>
            {children}
        </div>
    );
};
